import { Routes } from '@angular/router';

export const DESKTOP_MODULE_ROUTES: Routes = [];
